import UserMenu from '../../../../../components/stories/organisms/top-navigation/components/user-menu'
import { useHistory } from 'react-router-dom'
import {
  useAccessSearchParam,
  useAuthStore
} from '../../../../../zustand/authentication/use-auth-store'
import { getUser } from '../../../../../react-query/authentication/queries/use-me-query'
import { usersAPI } from '../../../../../../proxyConfig/apiUrls'
import { DateTime } from 'luxon'
import { useMemo } from 'react'
import UserLicense from '../components/user-license'
import { useGetSubscriptionsQuery } from '../../../../../react-query/authentication/queries/use-subscription-query'

const Users = () => {
  const { push } = useHistory()
  const { logout } = useAuthStore()
  const user = getUser()
  const accessSearchParam = useAccessSearchParam()
  const { data: subscriptionData, isLoading } = useGetSubscriptionsQuery()

  const handleNavigateUserSettings = () => {
    push('/userSettings')
  }

  const handleLogout = () => {
    logout()
  }

  const appVersion = useMemo(
    () => (
      <>
        {import.meta.env.VITE_REACT_APP_VERSION}-
        {!!import.meta.env.VITE_TARGET_ENV &&
          import.meta.env.VITE_TARGET_ENV !== 'production' &&
          import.meta.env.VITE_TARGET_ENV.substring(0, 2)}
      </>
    ),
    []
  )

  const profilePicture = useMemo(
    () => `${usersAPI}/${user?.userId}/avatar${accessSearchParam()}`,
    [user?.userId]
  )

  const hasUntilDate =
    subscriptionData?.organisationSubscription?.runtime?.mode === 'EXPIRES'

  const endDate = hasUntilDate
    ? DateTime.fromISO(
        subscriptionData?.organisationSubscription?.runtime?.end
      ).endOf('day')
    : null

  const isExpired = endDate?.isValid ? DateTime.now() > endDate : false

  return (
    <UserMenu
      key="user-menu"
      userData={{
        name: `${user?.firstName} ${user?.lastName}`
      }}
      profilePicture={profilePicture}
      onClickUserSettings={handleNavigateUserSettings}
      onClickLogout={handleLogout}
      appVersion={appVersion}
      isExpired={isExpired}
    >
      <UserLicense
        subscriptionData={subscriptionData}
        isExpired={isExpired}
        isLoading={isLoading}
        endDate={endDate}
      />
    </UserMenu>
  )
}

export default Users
